import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from 'app/services/auth.guard';
import { EmailSubdomainGuard } from 'app/services/email-subdomain.guard';
import { CreatePlanDocumentComponent } from './components/create-plan-document/create-plan-document.component';
import { DocumentPlanningComponent } from './components/document-planning/document-planning.component';

const routes = [
  {
    path: 'document/create-plan',
    component: CreatePlanDocumentComponent,
    canActivate: [AuthGuard, EmailSubdomainGuard],
  },
  {
    path: 'document/create-plan/:id',
    component: CreatePlanDocumentComponent,
    canActivate: [AuthGuard, EmailSubdomainGuard],
  },
  {
    path: 'document/planning/:id',
    component: DocumentPlanningComponent,
    canActivate: [AuthGuard, EmailSubdomainGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class DocumentRoutingModule {}
